import script from "./AlbumsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumsDetail.vue?vue&type=script&setup=true&lang=js"

import "./AlbumsDetail.vue?vue&type=style&index=0&id=64643af4&lang=css"

const __exports__ = script;

export default __exports__